import { FEATURE_FLAGS } from "@cede/types";
import { useFeatureFlagValue } from "@/hooks/feature-flags";

export const useSupportedCexPerps = () => {
  const allCexPerpsExchanges = useFeatureFlagValue(FEATURE_FLAGS.ALL_CEX_PERPS_EXCHANGES, "") as string;
  const supportedCexPerps = allCexPerpsExchanges?.split(",").filter(Boolean) ?? [];
  return supportedCexPerps;
};
